import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import SplashScreen from 'src/components/SplashScreen';
import { setUserData, logout } from 'src/actions/accountActions';
import authService from 'src/services/authService';
import { socketBaseURL } from 'src/constants';
import socketio from 'socket.io-client';
import { SocketContext } from 'src/context/SocketContext';
function Auth({ children }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isLoading, setLoading] = useState(true);
  const { setSocket } = useContext(SocketContext);

  useEffect(() => {
    const clearAuthentication = async () => {
      setSocket(current => {
        if (current) current.disconnect();
        return null;
      });
      await dispatch(logout());
      history.replace('/login');
    };
    const initAuth = async () => {
      authService.setAxiosInterceptors({
        onLogout: clearAuthentication
      });

      authService.handleAuthentication();

      if (authService.isAuthenticated()) {
        try {
          const user = await authService.loginInWithToken();
          let newsocket = socketio.connect(socketBaseURL, {
            query: {
              token: localStorage.getItem('accessToken')
            }
          });

          setSocket(newsocket);

          await dispatch(setUserData(user));
        } catch (error) {
          await clearAuthentication();
        }
      } else {
        await dispatch(logout());
      }

      setLoading(false);
    };

    initAuth();

    // eslint-disable-next-line
  }, [dispatch]);

  if (isLoading) {
    return <SplashScreen />;
  }

  return children;
}

Auth.propTypes = {
  children: PropTypes.any
};

export default Auth;
